<template>
<!--    <el-menu v-if="!isCollapse" :router="true" :default-active="activeLink"-->
<!--             class="el-menu-vertical-demo" :class="{'hide-menu-mobile':isCollapse}" :collapse="isCollapse">-->
        <div>

            <el-menu-item index="Bus">
                <i class="el-icon-location"></i>
                <span slot="title">Bus</span>

            </el-menu-item>
            <el-menu-item index="add-bus-station">
                <i class="el-icon-location"></i>
                <span slot="title">Add Station</span>
            </el-menu-item>


            <el-menu-item index="add-base">
                <i class="el-icon-odometer" style="width:32px; height: 20px; color:#46A0FC"></i>
                <span slot="title">Add Base</span>
            </el-menu-item>


            <el-menu-item index="profile">
                <i class="el-icon-odometer" style="width:32px; height: 20px; color:#46A0FC"></i>
                <span slot="title">Profile</span>
            </el-menu-item>
        </div>
<!--    </el-menu>-->
</template>

<script>
    export default {
        props: ['isCollapse', 'activeLink']
    }
</script>
<style lang="scss" scoped>
    .packageIcon {
        width: 32px;
        height: 20px;
        color: #46A0FC
    }

    .sidebar {
        border-right: 1px solid #e6e6e6;

        .el-menu {
            border-right: 0px;
            text-align: left;
        }

        .el-menu-vertical-demo:not(.el-menu--collapse) {
            width: 220px;
        }
        .el-submenu-vertical-demo:not(.el-submenu--collapse) {
            width: 220px;
        }

        .el-submenu{
            border-right: 0px;
            text-align: left;
        }

        .collapsed {
            background-color: grey;
        }

        .el-menu-vertical-demo {
            height: 100vh;
        }

        .hotel-details {
            min-height: 60px;
            padding: 0 20px;
            border-bottom: 1px solid #e6e6e6;
            display: flex;
            align-items: center;

            @media screen and (max-width: 768px) {
                border-bottom: 1px solid #e6e6e6;
                display: flex;
                flex: 1;
            }

            .property-name-code {
                display: flex;
                flex-direction: column;
                margin-top: 6px;
                margin-left: 10px;

                @media (max-width: 768px) {
                    flex: 3;
                }
            }

            .property-icon {
                @media screen and (max-width: 768px) {
                    display: flex;
                    flex: 1;
                    justify-content: space-between;
                }

                .size-36 {
                    width: 36px;
                }

                .size-48 {
                    width: 48px;
                }
            }

            .hamburger {
                display: none;
                cursor: pointer;
                border: 1px solid #e6e6e6;
                border-radius: 4px;
                height: 40px;
                align-items: center;
                justify-content: center;
                width: 40px;

                @media screen and (max-width: 768px) {
                    display: flex;
                }

            }

            .hamburger:hover {
                background-color: #e6e6e6;
            }

        }
    }

    .content-wrapper {
        flex: 1;
        display: flex;

        .sidebar {

        }

        .content {
            /*padding-bottom: 10px;*/
            flex: 1;

            .box-card {
                margin-bottom: 10px;
            }
        }
    }
</style>
